import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines } from "@/components/Motion";
import { EASE } from "@/lib/api";

const HeroVisual = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "10%"]);

  return (
    <div ref={ref} className="relative">
        <motion.div
          initial={{ clipPath: "inset(100% 0 0 0 round 999px 999px 0 0)" }}
          animate={{ clipPath: "inset(0% 0 0 0 round 999px 999px 0 0)" }}
          transition={{ duration: 1.6, delay: 0.3, ease: EASE }}
          className="relative h-[460px] sm:h-[560px] lg:h-[680px] overflow-hidden rounded-t-[999px] bg-cocoa"
        >
          <motion.img
            data-testid="hero-image"
            src="/img/cupcake-hero.jpg"
            alt="Banana Biscoff cupcake with hand-piped frosting"
            style={{ y: imgY }}
            initial={{ scale: 1.35 }}
            animate={{ scale: 1.15 }}
            transition={{ duration: 2.2, delay: 0.3, ease: EASE }}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </motion.div>
    </div>
  );
};

export const Hero = () => (
  <section data-testid="hero-section" className="relative mx-auto max-w-[1440px] px-5 md:px-10 pt-36 md:pt-44 pb-24 md:pb-36 overflow-hidden">
    <div className="grid lg:grid-cols-12 gap-14 lg:gap-10 items-end">
      <div className="lg:col-span-7 relative z-10">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.1, ease: EASE }} className="eyebrow flex items-center gap-4">
Boutique Dessert Studio · Philadelphia Area
        </motion.p>
        <MaskLines
          onLoad
          as="h1"
          testId="hero-title"
          delay={0.2}
          stagger={0.14}
          className="mt-8 font-display font-light text-[4rem] sm:text-[6rem] lg:text-[7.5rem] xl:text-[8.4rem] leading-[0.9] tracking-[-0.02em] text-espresso"
          lines={[
            "Lise’s",
            <span className="pl-[0.9em] italic text-mocha">Sugar</span>,
            "Studio",
          ]}
        />
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, delay: 0.9, ease: EASE }} className="mt-10 lg:pl-[0.9em] max-w-xl">
          <p data-testid="hero-tagline" className="font-display italic text-3xl md:text-4xl text-cocoa">Sweet creations, thoughtfully made.</p>
                    <div className="mt-9 flex flex-wrap gap-3">
            <Link to="/shop" data-testid="hero-cta-shop" className="btn btn-dark">Shop Desserts</Link>
            <Link to="/custom-orders" data-testid="hero-cta-custom" className="btn btn-line">Custom Orders</Link>
          </div>
        </motion.div>
      </div>
      <div className="lg:col-span-4 lg:col-start-9">
        <HeroVisual />
      </div>
    </div>
  </section>
);
